import { Component, ViewChild, OnInit, OnDestroy, Input, Renderer2, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { EmrReportsService } from '../emr-report.service';
import { EmrHtmlTemplatesService } from '../../../pat-html-reports/emr-html-templates/emr-html-templates.service';
import { AppCodeGroup, ControlsParams, UserSessionService, SheetParms, UIAction, UISessionKeys } from '../../../shared';
import { ModalService, SelectizeComponent, ToastService } from '../../../blocks';
import { takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
import { MedicalRepositoryService } from '../../medical-repository.service';
import { DocManagementTrans } from '../../../document-management/interface/doc-manag-model';
import { SnDocumentType } from '../../../document-management/document-type';
import { MedicalControllerService } from '../../medical-controller.service';
import { IVisitData } from '../../emr-general-methods';
import { EmrHtmlReports } from '../../interface/interface';
import { CKEditorComponent } from '@ckeditor/ckeditor5-angular';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DevExpressHelperComponent } from '../../../blocks/dev-express-viewer/dev-express-helper.component';

@Component({
    selector: 'app-emr-report-write',
    templateUrl: './emr-report-write.component.html',
    styleUrls: ['./emr-report-write.component.css']
})
export class EmrReportWriteComponent implements OnInit, OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    devExpressHelperComponent: DevExpressHelperComponent;
    public content: string = '';
    emrHtmlTemplate: any;
    @Input() reportType: number;
    @Input() _displayType: number = 1;
    visitData: IVisitData = <IVisitData>{};
    lastVisitSerial: number;
    serviceId: number;
    controlsParams: ControlsParams;
    showPrint: number = 0
    showScan: boolean = false;
    emrHtmlTemplateSerial: number = null;
    selectedPatient: any = <any>{};
    visitSerial: number;
    regPatServiceSerial: number;
    emrHtmlReportSerial: number = 0;
    emrHTMLReports: any[] = [];
    editableContent: boolean = true;
    mode: number;
    currentTrans: any;
    elnaeemReport: number;
    htmlObject: any = <any>{};
    appendingDataObj: any = <any>{};
    report: EmrHtmlReports = <EmrHtmlReports>{};
    iframeSrc: SafeHtml;
    textContent: string
    docCode: number;
    editorConfig = {
        base_url: '/tinymce', // Root for resources
        suffix: '.min',
        height: 500,
        plugins: 'lists link image table code help wordcount',
        toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | link image',
    };
    @ViewChild('btnCtrl') btnCtrl: any;
    @ViewChild('patVisit') patVisit: SelectizeComponent;
    @ViewChild('htmlTemplate') htmlTemplate: SelectizeComponent;
    @ViewChild('ckeditors') ckeditor: CKEditorComponent;
    constructor(
        public translate: TranslateService,
        public _medicalRepo: MedicalRepositoryService,
        private _route: ActivatedRoute,
        private _userSessionService: UserSessionService,
        private _modalService: ModalService,
        private _medicalController: MedicalControllerService,
        private _emrReportsService: EmrReportsService,
        private _emrHtmlTemplatesService: EmrHtmlTemplatesService,
        private sanitizer: DomSanitizer,
        private _toaster: ToastService,
    ) {

        this.controlsParams = new ControlsParams(77, AppCodeGroup.Buttons, true);
        _route.params.pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(val => {
                this.mode = +val['mode'];
            });
        _medicalRepo.sharedMedicalData$.subscribe(pat => {
            if (pat && Object.keys(pat).length) {
                this.selectedPatient = _medicalRepo.PatientData;
                this.selectedPatient.lastVisitSerial = _medicalRepo.PatientData.visitSerial;
                this.selectedPatient.code = _medicalRepo.PatientData.patientCode;
                this.mode = 100;
            }
        })
        this.devExpressHelperComponent = new DevExpressHelperComponent;

    }
    ngOnInit() {
        this._userSessionService.getUIState$(UISessionKeys.Transactions).subscribe(state => {
            this.currentTrans = state;
        });
        this._userSessionService.subscribeToKey$('patient')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys.value) {
                    this.reset();
                    this.selectedPatient = keys.value;
                    this.headerAndPatDataObj.patCode = this.selectedPatient.code;
                }
            });
        this._userSessionService.subscribeToKey$('EditableHtmlReport')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys.value) {
                    this.emrHtmlReportSerial = keys.value.emrRepSerial;
                    this.editHtmlReport(this.emrHtmlReportSerial);
                }
            });
        this._userSessionService
            .subscribeToKey$('hasHtmlReportSerial').pipe(
                takeUntil(this.ngUnsubscribe))
            .subscribe(res => {
                if (res && res.value && res.value.service) {
                    let ww = res.value.service[0]
                    this.selectedPatient.code = ww.patientCode;
                    this.selectedPatient.lastVisitSerial = ww.visitSerial;
                }

            });
        this.activeHtmlReportStepper$();
        this.visitData$();
        this._userSessionService.subscribeToKey$('WriteReportToService')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys.value) {
                    this.reset()
                    this.visitSerial = keys.value.vSerial;
                    this.regPatServiceSerial = keys.value.regPatServiceSerial;
                    this.elnaeemReport = keys.value.elnaeemReport;
                    this.headerAndPatDataObj.patCode = this.selectedPatient.code;
                    this.headerAndPatDataObj.visitSerial = this.visitSerial;
                    this.headerAndPatDataObj.serviceCode = this.serviceId;
                    this.docCode = this._medicalRepo.PatientData.docCode;
                    this.headerAndPatDataObj.regPatServiceSerial = this.regPatServiceSerial;
                    this.getPatientReport()
                }
            });

    }
    visitData$() {
        this._userSessionService.subscribeToKey$('visitData')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys && keys.value && Object.keys(keys.value)) {
                    this.visitData = keys.value;
                    this.editableContent = keys.value.editableContent;
                    // this.favoriteFindList = this._medicalRepo.emrMedicalDataRepo.FavoriteList ?
                    // this._medicalRepo.emrMedicalDataRepo.FavoriteList.filter(el => el.favoriteType == 3) : [];
                    if (this._medicalRepo.emrMedicalDataRepo
                        && this._medicalRepo.emrMedicalDataRepo.emrHTMLReports
                        && this._medicalRepo.emrMedicalDataRepo.emrHTMLReports.length > 0)
                        this.emrHTMLReports = this._medicalRepo.emrMedicalDataRepo.emrHTMLReports;
                    else
                        this.getemrHTMLReports();
                }
            });
    }
    // HtmlReportDateLoad() {
    //     this._emrReportsService.HtmlReportDate(this.serviceId)
    //         .pipe(takeUntil(this.ngUnsubscribe))
    //         .subscribe(res => {
    //             this.content = ''
    //             this.editableContent = true;
    //             this.content = res.data[0]['htmlContent'];

    //             this.emrHtmlReportSerial = res.data[0].serial ? res.data[0].serial : 0;
    //             this.getReportData()

    //         });
    // }

    getemrHTMLReports() {
        if (this.visitData.visitSerial > 0) {

            this._emrReportsService.getHtmlReportDate(this.visitData.visitSerial)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(res => {
                    if (res) {
                        this._medicalRepo.emrMedicalDataRepo.emrHTMLReports = res.data;
                        this.emrHTMLReports = res.data;
                    }
                });
        }
        else {

        }
    }
    // active stepper after changes
    activeHtmlReportStepper$() {
        if (this.btnCtrl) {
            this._userSessionService.setBtnCtrl(this.btnCtrl);
        }
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    reset() {
        this.iframeSrc = this.sanitizer.bypassSecurityTrustHtml('<div></div>');
        this.emrHtmlReportSerial = 0;
        this.content = '';
        this.textContent = '';
        this.report = <EmrHtmlReports>{};
        if (this.patVisit) {
            this.patVisit.clear();
            this.patVisit.clearItems();
        }
        if (this.htmlTemplate) {
            this.htmlTemplate.clear();
            this.htmlTemplate.clearItems();
        }
    }
    editHtmlReport(serial: number) {
        this._emrReportsService
            .writtenReportsSearch(<SheetParms>{ editMode: true, serial: serial })
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(res => {
                if (res && res.data && res.data.length > 0) {
                    this.emrHtmlTemplateSerial = res.data[0].emrHtmlTemplatesSerial;
                    this.selectedPatient.code = res.data[0].patCode;
                    this.selectedPatient.lastVisitSerial = res.data[0].visitSerial;
                    this.content = res.data[0].htmlContent;
                }
            });

    };
    headerAndPatDataObj: any = {}
    getRadRepMainHeader() {
        if (!this.headerAndPatDataObj.visitSerial) {
            this.headerAndPatDataObj.visitSerial = this.selectedPatient.lastVisitSerial
        }
        this.htmlObject.innerHTML = '';
        this._emrHtmlTemplatesService.getRadRepMainHeader(this.headerAndPatDataObj).pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe(res => {
                // if (res.returnFlag && res.data.length > 0) {
                //     let headers: any = [];
                //     if (this.translate.currentLang == 'ar') {
                //         headers = res.data.filter(ele => ele.langId === 1)
                //         this.mainHeaderAr = headers[0].htmlContent;
                //     }
                //     else {
                //         headers = res.data.filter(ele => ele.langId === 2)
                //         this.mainHeaderEn = headers[0].htmlContent;
                //     }
                // }
                this.htmlObject = document.createElement('div');
                // if (this.translate.currentLang == 'ar' && this.mainHeaderAr !== '') {
                //     this.htmlObject.innerHTML = '<div style="margin-bottom:40px">' + this.mainHeaderAr + '</div>';
                // }
                // else if (this.translate.currentLang == 'en' && this.mainHeaderEn !== '') {
                //     this.htmlObject.innerHTML = '<div style="margin-bottom:40px">' + this.mainHeaderEn + '</div>';
                // }
                if (res.data1.length > 0) {
                    this.currentService = res.data1[0];
                }
                if (res.data3.length > 0 && res.data1.length == 0) {
                    this.currentService = res.data3[0];
                }
                this._userSessionService.setSessionKey("patServiceData", this.currentService)

                // this.content = this.htmlObject.innerHTML;
            })



    }
    mainHeaderAr: any = '';
    mainHeaderEn: any = '';
    currentService: any;
    footerAr: any;
    footerEn: any;
    resetIframe() {
        this.iframeSrc = this.sanitizer.bypassSecurityTrustHtml('<div></div>');
        // this.iframeSrc = this.sanitizer.bypassSecurityTrustHtml('<textarea name="impression" style="height: 114px; width: 1781px;">No tethered cord or other development spinal anomaly.</textarea>');

    }
    onTemplateSelect(item: any) {
        this.getRadRepMainHeader();
        this.resetIframe()
        if (item == null) {
            this.resetTemplateCode();
        }
        else
            if ((item != null && item['AutoEmited'] == false) || (item != null && item.emrHtmlTemplatesSerial)) {
                this.emrHtmlTemplateSerial = item.code ? item.code : item.emrHtmlTemplatesSerial;
                this._emrHtmlTemplatesService.getEmrHtmlTemplates(this.emrHtmlTemplateSerial)
                    .pipe(takeUntil(this.ngUnsubscribe))
                    .subscribe(
                        repContent => {
                            if (repContent && repContent.data && repContent.data.length > 0) {
                                if (this.currentService && this.currentService.patCode > 0) {
                                    let html = '';
                                    this.emrHtmlTemplate = repContent.data[0];
                                    this.content = this.emrHtmlTemplate['htmlContent'];
                                    html = this.emrHtmlTemplate['htmlContent'];
                                    this.htmlObject.innerHTML = this.htmlObject.innerHTML + html;
                                    this._userSessionService.setSessionKey("patServiceData", this.currentService)
                                    this.replaceValuesById('patnamecell', this.currentService.patientNameCell);
                                    this.replaceValuesById('patcodecell', this.currentService.patCodeCell);
                                    this.replaceValuesById('agecell', this.currentService.patientAgeCell);
                                    this.replaceValuesById('transdatecell', (this.currentService.startDateCell));
                                    this.replaceValuesById('cliniccell', (this.currentService.cliniccell));
                                    this.replaceValuesById('diagnoisecell', (this.currentService.diagnoisecell));
                                    this.replaceValuesById('doctordoarcell', this.currentService.doctorNameCell);
                                    // this.replaceValuesById('servicecell', this.currentService.serviceNameAr);
                                    // this.replaceValuesById('docnamecell', this.currentService.doctorNameAr);
                                    // this.replaceValuesById('transerialcell', this.currentService.orderNumber);
                                    // this.replaceValuesById('transdatecell', (this.currentService.orderDate));
                                    // this.replaceValuesById('resultdatecell', this.currentService.expectedStartTime);
                                    // this.replaceValuesById('patplacecell', this.currentService.placeNameAr);
                                    // this.replaceValuesById('visittypearcell', this.currentService.visitTypeAr);
                                    // this.replaceValuesById('ser', this.currentService.regPatServiceSerial);
                                    if (this.currentService.gender == '2') {
                                        this.currentService.gender = 'Female'
                                    }
                                    else {
                                        this.currentService.gender = 'Male'
                                    }
                                    this.replaceValuesById('gender', this.currentService.gender);
                                    if (this.currentService.invSer) {
                                        this.replaceValuesById('invSer', this.currentService.invSer);
                                    }
                                    // this.footerAr = "<h3> Doctor Sign / " + this.currentService.doctorNameEn ? this.currentService.doctorNameEn : '' + "</h3>";
                                    // this.footerEn = "<h3> Doctor Sign / " + this.currentService.doctorNameEn ? this.currentService.doctorNameEn : '' + "</h3>";
                                    this.footerAr = '';
                                    this.footerEn = '';

                                    if (this.translate.currentLang == 'ar') {
                                        this.content = this.htmlObject.innerHTML + this.footerAr;
                                    }
                                    else {
                                        this.content = this.htmlObject.innerHTML + this.footerEn;
                                    }
                                    //this.iframeSrc = this.sanitizer.bypassSecurityTrustHtml(this.content);
                                } else {
                                    this.getRadRepMainHeader();
                                }

                            }
                        },
                        error => console.log(error),
                        () => {
                            //this.getReportData();
                        });
            }

    }
    replaceValuesById(idName, value) {  //#######Azmio 21-11-2023
        if (this.htmlObject && this.htmlObject != '') {
            if (this.htmlObject.querySelector('#' + idName)) {
                if (this.htmlObject.querySelector('#' + idName).innerHTML) {
                    this.htmlObject.querySelector('#' + idName).innerHTML = value
                }
            }
        }
    }

    resetTemplateCode() {
        this.emrHtmlTemplateSerial = null;
    }

    getReportData() {
        this._emrReportsService
            .getReportData(<SheetParms>{
                reportType: this.reportType ? this.reportType : this.mode,
                visitSerial: this.selectedPatient.lastVisitSerial
            }).subscribe(
                res => {
                    if (res && res.data && res.data.length > 0) {
                        this.appendingDataObj = res.data[0];
                    }
                },
                error => console.log(error),
                () => {
                    this.setReportData(this.appendingDataObj);

                });
    }
    //- assign data  to div(s) in the report 
    setReportData(obj: any) {
        var iframeCkeditor = document.getElementsByTagName('iframe');
        if (iframeCkeditor && iframeCkeditor.length > 0) {
            var ckeditorDocument = iframeCkeditor[0].contentDocument;
        }
        if (ckeditorDocument) {
            this.htmlObject = ckeditorDocument.querySelector("table[id ='MainTableDemed']");

            let appendingDataItems = Object.entries(obj);
            for (let item of appendingDataItems) {
                this.setValueById(item[0], item[1]); // item[0]:key , item[1]:value
            }

        }
    }

    setValueById(id: string, value: any) {

        if (id && value && this.htmlObject && this.htmlObject != null) {
            let divHtmlElement = this.htmlObject.querySelector(`div[id = ${id}]`)
            if (divHtmlElement) {
                divHtmlElement.innerHTML = value.toString();
            }
        }
    }

    onBtnClicked(btn: number) {
        switch (btn) {
            case 1:
            case -1000://save code
                this.save();
                break;
        }
    }
    docManagementData: DocManagementTrans = {
        documentLookupCode: SnDocumentType.PersonnalImages,
        dataStatus: undefined
    };

    save() {
        let emrHtmlReport = <SheetParms>{
            serial: this.emrHtmlReportSerial,
            patCode: this.selectedPatient.code,
            visitSerial: this.selectedPatient.lastVisitSerial,
            reportType: this.reportType ? this.reportType : this.mode,
            htmlContent: this.content ? this.content : '',
            emrHtmlTemplatesSerial: this.emrHtmlTemplateSerial,
            RegPatServiceSerial: this.regPatServiceSerial,
            textContent: this.textContent,
            docCode: this.docCode

        };
        if (this.elnaeemReport == 1) {
            emrHtmlReport.htmlContent = '<div>' + this.textContent + '</div>'
        }
        console.log(this.emrHtmlReportSerial)
        if (this.emrHtmlReportSerial == 0) {
            this._emrReportsService.addWrittenReports(emrHtmlReport)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(
                    res => {
                        if (res) {
                            if (res.data && res.data.length > 0) {
                                this.emrHtmlReportSerial = res.data[0].emrHtmlReportsSerial;
                            }
                            if (res.returnFlag == true) {
                                this._userSessionService.setUIStateAction({ type: UIAction.CommitTrans, payload: this.currentTrans['NewHtmlReport'] });
                                this.showScan = true
                            }
                            if (this.elnaeemReport == 1) {
                                this.getPatientReport()
                            } else {

                                this.getemrHTMLReports()
                            }

                        }
                    });
        }
        else {
            this._emrReportsService.updateWrittenReports(emrHtmlReport)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(
                    res => {
                        if (this.elnaeemReport == 1) {
                            this.getPatientReport()
                        } else {

                            this.getemrHTMLReports()
                        }
                    });
        }
    }

    deleteRow(item: any) {
        if (item.serial) {
            this._modalService.activeDelMes(String(item.serial), String(item.serial)).then(responseOK => {
                if (responseOK) {
                    item['deleteStatus'] = 1;

                    this._emrReportsService.deleteHtmlReportData(item.serial)
                        .pipe(takeUntil(this.ngUnsubscribe))
                        .subscribe(res => {
                            if (res) {
                                if (this.elnaeemReport == 1) {
                                    this.getPatientReport()
                                } else {

                                    this.getemrHTMLReports()
                                }
                                //this.editFindings = false
                            }
                        });
                }
            });
        }
        else {
            let ind = this.emrHTMLReports.indexOf(item);
            this.emrHTMLReports.splice(ind, 1);
        }
    }
    //=============================================Eng/Mostafa Mahmoud ==========================================================================
    getPatientReport() {
        this._emrReportsService.HtmlReportDate(this.regPatServiceSerial)
            .subscribe(res => {
                if (res && res.data && res.data.length > 0) {
                    this.report = res['data'][0];
                    this.emrHtmlReportSerial = this.report.serial
                    this.emrHtmlTemplateSerial = this.report.emrHtmlTemplatesSerial;
                    this.selectedPatient.code = this.report.patCode;
                    this.selectedPatient.lastVisitSerial = this.report.visitSerial ? this.report.visitSerial : this.visitSerial;
                    this.textContent = this.report.textContent
                    this.showPrint = 1

                }
                else {
                    this.selectedPatient.lastVisitSerial = this.visitSerial
                    this.showPrint = 0
                }
            }, err => console.error(err),
                () => {
                    setTimeout(() => {
                        this.content = this.decodeHtmlEntities(this.report.htmlContent);
                    }, 500);
                });
    }
    //=============================================Eng/Mostafa Mahmoud ==========================================================================
    decodeHtmlEntities(html: string): string {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = html;
        return textarea.value;
    }

    //====================================devExpress===============================================
    currentUser: any = {};
    repLink: any
    printReportWrite() {
        let parm = {};
        parm['VisitSerial'] = this.visitSerial;
        parm['PatCode'] = this.selectedPatient.code;
        parm['RegPatServiceSerial'] = this.regPatServiceSerial;
        parm['EmrHtmlReportSerial'] = this.emrHtmlReportSerial;
        parm['EmrHtmlTemplatesSerial'] = this.emrHtmlTemplateSerial;
        parm['ReportType'] = 2;
        parm['ReportNameAr'] = "تقرير المريض";
        parm['ReportNameEn'] = "Patient Report";
        this.devExpressHelperComponent.showReport(parm, 'DoctorReports', 'UltrasoundReport', 'Reports.Doctor.UltrasoundReport,DoctorReports');

    }
    //====================================onTemplateSelect===============================================


    TemplateSelect(item: any) {

        if ((item != null && item['AutoEmited'] == false) || (item != null && item.emrHtmlTemplatesSerial)) {
            this.emrHtmlTemplateSerial = item.code ? item.code : item.emrHtmlTemplatesSerial;
            this._emrHtmlTemplatesService.getEmrHtmlTemplates(this.emrHtmlTemplateSerial)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(
                    res => {
                        if (res && res.data && res.data.length > 0) {
                            var convertHtmlContent = res.data[0]['htmlContent'].replace(/<[^>]*>/g, '');
                            var finalRepRemplate = convertHtmlContent.replace(/\&nbsp;/g, '');
                            this.textContent = finalRepRemplate;
                        }
                    },
                    error => console.log(error),
                    () => {
                        //this.getReportData();
                    });
        }

    }

}

